import React from "react";
import logo from "../../assets/logo-white.png";

import {
  Container,
  Column,
  Link,
  Paragraph,
  ImageContainer,
} from "./Components";

const Navbar = () => {
  return (
    <Container>
      <ImageContainer>
        <img style={{width: '100%', height: 'auto', marginRight: '10px'}} src={logo} alt="logo" />
      </ImageContainer>
      <Column hideMobile>
        <Link href="/about"><Paragraph link>A Feira e o Dão</Paragraph></Link>
        <Link href="/program"><Paragraph link>Programa</Paragraph></Link>
        <Link href="/map"><Paragraph link>Rota dos Produtores</Paragraph></Link>
        <Link href="/terms"><Paragraph link>Política de Privacidade</Paragraph></Link>
      </Column>
      <Column hideMobile>
        <Link target="_blank" href="https://www.facebook.com/feiradovinhododao/"><Paragraph link>Facebook</Paragraph></Link>
        <Link target="_blank" href="https://www.instagram.com/feiradovinhododao/"><Paragraph link>Instagram</Paragraph></Link>
        <Link target="_blank" href="https://www.livroreclamacoes.pt/inicio/reclamacao"><Paragraph link>Livro de Reclamações</Paragraph></Link>
      </Column>
      <Column>
        <Paragraph big>Câmara Municipal de Nelas</Paragraph>
        <Paragraph>Largo do Município<br/> 3520-001 Nelas</Paragraph>
      </Column>
    </Container>
  );
};

export default Navbar;
